import { UPDATE_APP, UPDATE_RANGE, CLEAR_FILTER } from "./actionTypes";

export const updateApp = ({ platform, apiKey, name, environment }) => (
  dispatch
) => {
  if (platform === "Google") platform = "GoogleAction";
  dispatch({
    type: UPDATE_APP,
    payload: { platform: platform, apiKey: apiKey, name, environment },
  });
};

export const updateRange = (range) => (dispatch) => {
  dispatch({ type: UPDATE_RANGE, payload: { from: range.from, to: range.to } });
};

export const clearFilter = (range) => (dispatch) => {
  dispatch({ type: CLEAR_FILTER, payload: null });
};
